import buildUrl from '@utils/buildUrl.utils'

class StepStatusTrackerManager {
  data = []
  merchantId = null
  accountId = null

  constructor (merchantId, accountId, data) {
    if (!merchantId) throw new Error('Missing argument merchant id!')
    if (!accountId) throw new Error('Missing argument account id!')

    this.merchantId = merchantId
    this.accountId = accountId
    this.data = JSON.parse(JSON.stringify(data))
  }

  /**
   *
   * @param {*} dataDefault
   * @returns
   */
  adapter (dataDefault) {
    return dataDefault.map(item => this.formatToView(item))
  }

  /**
   * Executes all the methods
   * @returns Array
   */
  get () {
    return this.adapter(this.data)
  }

  formatInternalURL (pathParams) {
    return buildUrl({
      url: process.env.VUE_APP_DASH_URL,
      pathParams: `${this.merchantId}/${this.accountId}/${pathParams}`
    })
  }

  formatToView ({ label, status, link = { label: undefined }, description }) {
    if (!link?.external && link?.href) {
      link.href = this.formatInternalURL(link.href)
    }

    return {
      label,
      description,
      status,
      link: link
    }
  }
}

export default StepStatusTrackerManager
